import type { Doc } from "building-types/doc";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";

// TODO: this function should really be based on entityInBuilding
export function docEntityIsVisible(_doc: Doc, handle: DocEntityHandle): boolean {
  switch (handle.type) {
    case "EFFECT":
    case "VIEW_TEMPLATE":
    case "VIEW_TEMPLATE_OVERRIDE":
    case "CATALOG_ITEM":
    case "DATA_SEQUENCE":
    case "OPTION_TEMPLATE":
    case "OPTION_SET_OVERRIDES":
    case "OPTION_SET":
    case "OPTION_RULE":
    case "VIEW_3D":
    case "PLAN_VIEW":
    case "PLAN_SET_TEMPLATE":
    case "OPTION":
    case "PLAN_SET_TEMPLATE_CONFIG":
    case "CONTENT_TEMPLATE":
    case "CONTENT_TEMPLATE_INSTANCE":
    case "LOCAL_PARAMETER":
    case "GLOBAL_PARAMETER":
    case "ELEVATION_VIEW":
    case "OPTION_EFFECT":
    case "ENTITY_SETTINGS":
    case "SETTINGS":
    case "GENERATED_ENTITY":
    case "SELECTOR":
    case "VIEW_SELECTOR":
    case "EDIT_MODE":
    case "DOC_REF":
    case "SYSTEM_PARAMETER":
      return false;

    default:
      return true;
  }
}
